import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import { Outlet } from 'react-router-dom';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import styles from './SiteOverview.module.scss';
import { HOME_OVERVIEW_ASSETS, HOME_OVERVIEW_GEOFENCES } from '@casops/navigation';
import { GeofenceState, useListGeofencesQuery } from '@casops/store/apis/geofencesApi';

export const SiteOverview = () => {
  const { t } = useTranslation();

  // Don't use filters here as we need to check the Normal/RequireAttention state of all geofences.
  const { data } = useListGeofencesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  const requiresAttention = useMemo<boolean>(() => {
    return Boolean(data?.items.some(({ state }) => state === GeofenceState.RequireAttention));
  }, [data?.items]);

  const tabs = useMemo<NavTabModel[]>(
    () => [
      {
        title: t('Navigation.Assets'),
        to: HOME_OVERVIEW_ASSETS,
      },
      {
        title: t('Navigation.Geofences'),
        to: HOME_OVERVIEW_GEOFENCES,
        isDotted: requiresAttention,
      },
    ],
    [t, requiresAttention],
  );

  return (
    <div className={styles.overview}>
      <NavTabs tabs={tabs} hasBorder />
      <Outlet />
    </div>
  );
};

export default SiteOverview;
